import { render, staticRenderFns } from "./modalCreateOrEdit.vue?vue&type=template&id=96ec5d30&scoped=true&"
import script from "./modalCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./modalCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=96ec5d30&scoped=true&lang=css&"
import style1 from "./modalCreateOrEdit.vue?vue&type=style&index=1&id=96ec5d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ec5d30",
  null
  
)

export default component.exports